import React, { type FC } from "react";
import type { Operation } from "src/api/interfaces/permissions";
import checkPermission from "src/components/AICLayout/AICHeader/Permissions/PermissionCheckers";
import { useInboundDocument } from "src/components/Contexts/InboundDocumentContext";
import { usePermissions } from "src/components/Contexts/PermissionsContext";

const DefaultNotAllowedElement: FC = () => {
  return <div />;
};

const withPermissionsOrDefault = (
  Component: FC<any>,
  operation: Operation,
  NotAllowedElement?: FC<any>
): FC<any> => {
  return (props) => {
    const { permissions } = usePermissions();
    const { useCase, countryCode } = useInboundDocument();

    const isAuthorized = checkPermission(
      permissions,
      countryCode,
      useCase,
      operation
    );

    if (isAuthorized) {
      return <Component {...props} />;
    }
    return NotAllowedElement === undefined ? (
      <DefaultNotAllowedElement />
    ) : (
      <NotAllowedElement {...props} />
    );
  };
};

export default withPermissionsOrDefault;
